<!-- Property Details Hero Section Begin -->
<div *ngFor="let image2d of Bien?.image2ds | slice:0:1">
    <section class="pd-hero-section set-bg" attr.data-setbg="{{image2d?.srcimg}}"
            [ngStyle]="{'background-image': 'url(' + image2d?.srcimg + ')'}">
        <div class="container">
            <div class="row">
                <div class="col-lg-8 offset-lg-2">
                    <div class="pd-hero-text">
                        <p class="room-location"><i class="icon_pin"></i>{{Bien?.ville?.nomville}} - {{Bien?.quartier?.nomquartier}}</p>
                        <h2> {{Bien?.designation}} {{Bien?.estmoderne ? ('HEADER_PROPERTY.MODERN' | translate) : ('HEADER_PROPERTY.SIMPLE' | translate)}}</h2>
                        <div class="room-price">
                            <span>{{ 'HEADER_PROPERTY.COST' | translate }} {{ 'COMMON.COST_UNITS.' + 
                                (Bien?.unitecout?.libeleadjectif === 'par heure' ? 'PER_HOUR' : 
                                 Bien?.unitecout?.libeleadjectif === 'journalier' ? 'DAILY' : 
                                 Bien?.unitecout?.libeleadjectif === 'par mètre carré' ? 'PER_SQUARE_METER' : 
                                 Bien?.unitecout?.libeleadjectif === 'mensuel' ? 'MONTHLY' : 
                                 Bien?.unitecout?.libeleadjectif === 'horaire' ? 'HOURLY' : 
                                 Bien?.unitecout?.libeleadjectif === 'de vente' ? 'FOR_SALE' : 
                                 Bien?.unitecout?.libeleadjectif === 'hebdomadaire' ? 'WEEKLY' : 'MONTHLY') | translate }} : </span>
                            <p>{{Bien?.coutloyermensuel| currency:'XAF'}} </p>
                        </div>
                        <ul class="room-features">
                            <li>
                                <i class="fa fa-arrows"></i>
                                <p>{{Bien?.espacelocatif}} m<sup>2</sup> {{ 'HEADER_PROPERTY.AREA' | translate }}</p>
                            </li>
                            <li>
                                <i class='fas fa-couch'></i>
                                <p>{{Bien?.nbrsalon}} {{ 'HEADER_PROPERTY.LIVING_ROOMS' | translate }}</p>
                            </li>
                            <li>
                                <i class="fa fa-bed"></i>
                                <p>{{Bien?.nbrchambreacoucher}} {{ 'HEADER_PROPERTY.BEDROOMS' | translate }}</p>
                            </li>
                            <li>
                                <i class="fa fa-bath"></i>
                                <p>{{Bien?.nbrsallebain}} {{ 'HEADER_PROPERTY.BATHROOMS' | translate }}</p>
                            </li>
                            <li>
                                <i class="fa fa-car"></i>
                                <p>{{(Bien?.parking || Bien?.garage)?'1':'0'}} {{ 'HEADER_PROPERTY.GARAGE_PARKING' | translate }}</p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>